export default __webpack_public_path__ + "static/media/calculation.ae278e7b.png";